import { render } from "./kashtabro.vue?vue&type=template&id=12bf1300"
import script from "./kashtabro.vue?vue&type=script&lang=js"
export * from "./kashtabro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__